import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  Grid,
} from '@mui/material';
import Auth_APIs from '../../utilities/api/auth_api';
import { useNavigate, useLocation } from 'react-router-dom';

import { toast, ToastContainer } from 'react-toastify';
import Logo from '../../utilities/dummy_assets/MBF_Logo.png';
import mapITlogo from '../../utilities/dummy_assets/mapITlogo.png';
import expandleft from '../../utilities/dummy_assets/Expand_left.png';
import tinkerersLogo from '../../utilities/dummy_assets/tinkerersLogo.png';
import background from '../../utilities/dummy_assets/background.png';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import AdminPasswordAPIs from '../../utilities/api/AdminPasswordAPIs';
// import mail from '../../utilities/dummy_assets/mail.png';
import mail from '../../utilities/dummy_assets/mail.gif';
import Logos from '../../components/logos';
import PageTransition from '../../components/PageTransition/PageTransition';

const typographyStyle = {
  color: 'var(--Primary-Primary03, #5C5C5C)',
  fontFamily: 'Inter',
  fontSize: '0.875rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: 'normal',
  letterSpacing: '-0.01375rem',
  marginBottom: '0.25rem',
};

const boxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '.6rem',
  alignSelf: 'stretch',
};
const validation_schema = Yup.object({
  email: Yup.string().email('Invalid email address').required('Required'),
});

const styledTextField = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    '& fieldset': {
      border: '1.5px solid #B5B5B5', // Set custom border
    },
    '&:hover fieldset': {
      borderColor: '#007BFF', // Border color on hover
    },
    '&.Mui-focused fieldset': {
      borderColor: '#007BFF', // Border color when focused
    },
  },
};

const ForgotPassword = () => {
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState('');
  const [countdown, setCountdown] = useState(0);
  const [canResend, setCanResend] = useState(true);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: validation_schema,
    onSubmit: values => {
      setSubmittedEmail(values.email);
      AdminPasswordAPIs.ForgotPassword(values)
        .then(response => {
          setEmailSubmitted(true);
          setCountdown(60); // 60 second countdown
          setCanResend(false);
          toast.success('Password reset email sent successfully!');
        })
        .catch(error => {
          console.log(error);
          toast.error('error occured.');
        });
    },
  });

  // Countdown timer for resend functionality
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0 && !canResend) {
      setCanResend(true);
    }
    return () => clearTimeout(timer);
  }, [countdown, canResend]);

  // Warn user when they try to refresh or leave the page
  useEffect(() => {
    const handleBeforeUnload = event => {
      event.preventDefault();
      event.returnValue = ''; // Some browsers require this for custom message
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const handleResendEmail = () => {
    if (canResend) {
      const values = { email: submittedEmail };
      AdminPasswordAPIs.ForgotPassword(values)
        .then(response => {
          setCountdown(60);
          setCanResend(false);
          toast.success('Password reset email sent again!');
        })
        .catch(error => {
          console.log(error);
          toast.error('Error occurred while resending email.');
        });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: { xs: 'white', sm: '#F7F7F7' },
        backgroundImage: { xs: 'none', sm: `url(${background})` },
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* "Go to User Site" link */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          p: '16px 24px',
        }}
      >
        <span
          onClick={() =>
            (window.location.href = 'https://tinkerspace.mis.mapit.ai/login')
          }
          style={{
            color: 'var(--Accent-Accent-01, #0062CC)',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          Go to Student Site
        </span>
      </Box>

      {/* Centered Container for Form */}
      <PageTransition
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'center', // Center content vertically
          alignItems: 'center', // Center content horizontally
          padding: '1.5rem',
        }}
      >
        {/* Form Section with White Background */}

        <Box
          sx={{
            width: '100%',
            maxWidth: '26rem',
            padding: '2rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem',
            textAlign: 'center',
            backgroundColor: 'white',
            borderRadius: '16px',
            boxShadow: { xs: 'none', sm: '0 4px 6px rgba(0, 0, 0, 0.1)' },
          }}
        >
          {!emailSubmitted ? (
            // Original Form Content
            <>
              <Box sx={boxStyle}>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item>
                    <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>
                      Forgot Your Password?
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#8C8C8C',
                      }}
                    >
                      We will send you the instruction to the email address
                      below to reset your password.
                    </Typography>
                  </Grid>
                </Grid>

                <Typography sx={{ ...typographyStyle, fontSize: '16px' }}>
                  Email Address{' '}
                  <span style={{ color: '#FF4D4F', marginLeft: '2px' }}>*</span>
                </Typography>
                <TextField
                  sx={{
                    ...styledTextField,
                  }}
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  placeholder="Enter email address"
                  variant="outlined"
                  helperText={formik.errors.email}
                  FormHelperTextProps={{
                    style: {
                      marginLeft: 0,
                      color: '#FF4D4F',
                      fontSize: '0.75rem',
                      marginTop: '4px',
                    },
                  }}
                />
              </Box>

              {/* Reset Password Button */}
              <Button
                onClick={formik.handleSubmit}
                sx={{
                  padding: '0.75rem',
                  justifyContent: 'center',
                  alignItems: 'center',
                  alignSelf: 'stretch',
                  borderRadius: '12px',
                  background: 'var(--Accent-Accent-00, #007BFF)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: 'var(--Accent-Accent-01, #007BFF)',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontSize: '20px',
                    fontWeight: 600,
                    color: '#FFF',
                  }}
                >
                  Reset My Password
                </Typography>
              </Button>

              {/* Back to Login Button */}
              <Button
                onClick={() => navigate('/login')}
                sx={{
                  padding: '0.5rem 1rem',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'transparent',
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontSize: '1rem',
                    fontWeight: 600,
                    color: 'blue',
                    outline: 'none',
                    backgroundColor: 'transparent',
                    cursor: 'pointer',
                  }}
                >
                  Back to login
                </Typography>
              </Button>
            </>
          ) : (
            // Success State Content
            <>
              {/* Large Email Animation */}
              <img
                src={mail}
                alt="Email Sent Animation"
                style={{
                  width: 200,
                  height: 200,
                  // marginBottom: '0.5rem'
                }}
              />

              {/* Success Message */}
              <Typography
                sx={{
                  fontSize: '24px',
                  fontWeight: 600,
                  color: '#333',
                  // marginBottom: '0.5rem'
                }}
              >
                Check Your Email
              </Typography>

              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 400,
                  color: '#666',
                  // marginBottom: '2rem',
                  textAlign: 'center',
                }}
              >
                Please check the email address {submittedEmail} for instructions
                to reset your password.
              </Typography>

              {/* Resend Email Button */}
              <Button
                onClick={handleResendEmail}
                disabled={!canResend}
                sx={{
                  padding: '1rem',
                  justifyContent: 'center',
                  alignItems: 'center',
                  alignSelf: 'stretch',
                  borderRadius: '12px',
                  backgroundColor: canResend ? 'transparent' : '#f5f5f5',
                  border: `1px solid ${canResend ? '#007BFF' : '#ccc'}`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: canResend
                      ? 'rgba(0, 123, 255, 0.1)'
                      : '#f5f5f5',
                  },
                  '&:disabled': {
                    cursor: 'not-allowed',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontSize: '1rem',
                    fontWeight: 600,
                    color: canResend ? '#007BFF' : '#999',
                  }}
                >
                  {canResend ? 'Resend Email' : `Resend in ${countdown}s`}
                </Typography>
              </Button>
              {/* Back to Login Button */}
              <Button
                onClick={() => navigate('/login')}
                sx={{
                  padding: '1rem',
                  justifyContent: 'center',
                  alignItems: 'center',
                  alignSelf: 'stretch',
                  borderRadius: '12px',
                  background: 'var(--Accent-Accent-00, #007BFF)',
                  marginBottom: '1rem',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: 'var(--Accent-Accent-01, #007BFF)',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontSize: '1rem',
                    fontWeight: 600,
                    color: '#FFF',
                  }}
                >
                  Back to Login
                </Typography>
              </Button>
            </>
          )}
        </Box>
      </PageTransition>

      {/* Footer with "Powered by" */}
      <Logos />

      <ToastContainer />
    </Box>
  );
};

export default ForgotPassword;
